import { useEffect, useRef, useState } from 'react';

export interface WindowSize {
  width?: number;
  height?: number;
}

const callbackMap: Map<unknown, (size: WindowSize) => void> = new Map();

const getSize = (): WindowSize => {
  if (typeof window !== 'object') {
    return {
      width: undefined,
      height: undefined,
    };
  }
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
};

const handleResize = (): void => {
  const size = getSize();
  callbackMap.forEach((callback) => callback(size));
};

export default (): WindowSize => {
  const [windowSize, setWindowSize] = useState(getSize);
  const { current: id } = useRef({});

  // Effects only run on the client
  useEffect(
    (): (() => void) | void => {
      // Add the listener if this is the first one
      if (callbackMap.size === 0) {
        window.addEventListener('resize', handleResize);
      }

      callbackMap.set(id, () => setWindowSize(getSize()));

      return (): void => {
        callbackMap.delete(id);

        // Remove the listener if this is the last one
        if (callbackMap.size === 0) {
          window.removeEventListener('resize', handleResize);
        }
      };
    },
    // TODO: Make this dependency array exhaustive
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return windowSize;
};
